import { useTranslation } from 'react-i18next';

import { Messages } from '@ifs-gcp/components';

import { useAuditStore } from '@/store/auditStore';

import { AuditElements } from './audit-elements';
import { AuditTabs } from './audit-tabs';
import { TabNavigation } from './audit-tabs/tab-navigation';
import styles from './audit.module.scss';

type AuditProps = {
  auditCaseErrors?: string[];
};

export const Audit = ({ auditCaseErrors }: AuditProps) => {
  const audit = useAuditStore((state) => state.audit);
  const { t } = useTranslation();

  if (!audit) {
    return null;
  }

  return (
    <div className={styles.page}>
      <AuditTabs />

      <div className={styles.content}>
        {!!auditCaseErrors?.length && (
          <div className={styles.errorsWrapper}>
            <Messages
              messages={auditCaseErrors}
              type="error-box"
              headerText={t('errors.submission_error')}
              listTopParagraph={t('errors.submission_error_description')}
            />
          </div>
        )}
        <div className={styles.elementsWrapper}>
          <AuditElements />
        </div>

        <TabNavigation />
      </div>
    </div>
  );
};
